import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[nspNonNegative]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: NonNegativeValidatorDirective,
      multi: true,
    },
  ],
})
export class NonNegativeValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    return value < 0 ? { nonNegative: true } : null;
  }
}
